import { render, staticRenderFns } from "./TableCategories.vue?vue&type=template&id=0ec07290"
import script from "./TableCategories.vue?vue&type=script&lang=js"
export * from "./TableCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports